import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/myaeon.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-92101d38")

_pushScopeId("data-v-92101d38")
const _hoisted_1 = { class: "main login-component" }
const _hoisted_2 = { class: "login__flex-container" }
const _hoisted_3 = { id: "formLogin" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  style: {"margin-bottom":"20px","width":"100%","height":"auto","display":"block"}
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Log In ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_a_alert = _resolveComponent("a-alert")
  const _component_user_outlined = _resolveComponent("user-outlined")
  const _component_a_input = _resolveComponent("a-input")
  const _component_a_form_item = _resolveComponent("a-form-item")
  const _component_lock_outlined = _resolveComponent("lock-outlined")
  const _component_a_input_password = _resolveComponent("a-input-password")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_form = _resolveComponent("a-form")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_a_form, {
          layout: "vertical",
          class: "user-layout-login"
        }, {
          default: _withId(() => [
            (_ctx.isLoginError)
              ? (_openBlock(), _createBlock(_component_a_alert, {
                  key: 0,
                  type: "error",
                  "show-icon": "",
                  style: {"margin-bottom":"24px"},
                  message: "Sorry, something went wrong logging you in. Please check your internet connection and login credentials and try again."
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_a_form_item, null, {
              default: _withId(() => [
                _createVNode(_component_a_input, {
                  size: "large",
                  value: _ctx.username,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.username = $event)),
                  placeholder: "Username",
                  style: {"width":"100%"}
                }, {
                  prefix: _withId(() => [
                    _createVNode(_component_user_outlined, { class: "prefixIcon" })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withId(() => [
                _createVNode(_component_a_input_password, {
                  value: _ctx.password,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.password = $event)),
                  size: "large",
                  placeholder: "Enter Password"
                }, {
                  prefix: _withId(() => [
                    _createVNode(_component_lock_outlined, { class: "prefixIcon" })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { style: {"margin-top":"24px"} }, {
              default: _withId(() => [
                _createVNode(_component_a_button, {
                  size: "large",
                  type: "primary",
                  "html-type": "submit",
                  class: "login-button",
                  loading: _ctx.loading,
                  disabled: _ctx.loading,
                  onClick: _ctx.handleSubmit
                }, {
                  default: _withId(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }, 8, ["loading", "disabled", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ])
  ]))
})